"use client";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Arrow, ArrowRight } from "@/components/svg";
import Link from "next/link";
import AboutHeroSection from "@/components/AboutHeroSection";
import blog from "../../public/assets/images/blog/blog.png";
import "./blog.css";

const BlogPage = ({ blogs }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 10;

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs?.slice(indexOfFirstBlog, indexOfLastBlog);

  // const totalPages = Math.ceil(blogs?.length / blogsPerPage);
  const totalPages = blogs?.length ? Math.ceil(blogs.length / blogsPerPage) : 1;

  useEffect(() => {
    const reveal = () => {
      const reveals = document.querySelectorAll(".reveal");
      reveals.forEach((element) => {
        const windowHeight = window.innerHeight;
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 10;
        if (
          elementTop < windowHeight - elementVisible &&
          !element.classList.contains("active")
        ) {
          element.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", reveal);
    reveal();

    return () => window.removeEventListener("scroll", reveal);
  }, []);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <AboutHeroSection
        pillText=" ~ Blogs ~"
        title="Insights &"
        highlight="Inspiration"
        description=" Explore our blog for valuable industry insights, expert
                opinions, and creative inspiration. Stay updated on the latest
                trends, innovative solutions, and best practices that drive
                success in the digital world."
        imageAlt="Insights & Inspiration"
        image={blog}
      />
      <Container>
        <Row className="pb-5">
          {currentBlogs?.map((blog, index) => {
            let xlSize;
            const patternIndex = index % 4;
            if (patternIndex === 0 || patternIndex === 3) {
              xlSize = 4;
            } else {
              xlSize = 8;
            }

            return (
              <Col
                xl={xlSize}
                md={6}
                sm={12}
                className="gy-4 animation-bottom"
                key={blog?._id}
              >
                <div className="tilt-wrapper">
                  <div className="blog-card">
                    {blog?.tags?.length > 0 && (
                      <span className="badge-blog">{blog?.tags?.[0]}</span>
                    )}
                    <div className="position-relative">
                      <Image
                        src={
                          blog?.image?.[0]?.url ||
                          "/static-blog.png"
                        }
                        alt={blog?.title}
                        className="card__image"
                        width={600}
                        height={200}
                        onError={(e) => {
                          const target = e.target;
                          if (target.src !== "/static-blog.png") {
                            target.src = "/static-blog.png";
                          }
                        }}
                      />
                      <div className="blog-img-overlay" />
                    </div>
                    <div className="blog-card-body">
                      <div className="article-content">
                        <p className="article-date p-0">
                          {new Date(blog?.createdAt).toLocaleString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            hour12: true,
                          })}
                        </p>
                        <h4 className="mb-0 pb-0">{blog?.title}</h4>
                      </div>
                      <Link
                        href={`/blog/${encodeURIComponent(blog?.slug)}`}
                        aria-label={`view ${blog?.slug} page`}
                      >
                        <div className="arrow-button">
                          <span className="arrow-wrapper">
                            <Arrow
                              className="arrow arrow-top"
                              style={{ color: "#fff" }}
                            />
                            <Arrow
                              className="arrow arrow-bottom"
                              style={{ color: "#fff" }}
                            />
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>

        {/* Pagination Controls */}
        <Row className="justify-content-center pb-5">
          <Col xs="auto">
            <div className="pagination-controls d-flex gap-2">
              <div
                className="pag-box prev-blog prev"
                style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                <ArrowRight />
              </div>

              {[...Array(totalPages)].map((_, index) => (
                <div
                  key={index}
                  className={`  pag-box
                    ${currentPage === index + 1 ? "active" : ""}
                  `}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </div>
              ))}

              <div
                className="pag-box"
                style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                <ArrowRight />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BlogPage;
